'use client'

import { useExtracted } from 'next-intl'
import { oliveOutcomes } from '@/lib/marketing-config'

/**
 * The one place the "what do N olives buy" sentence is written. Names the
 * reference models explicitly — an unqualified "minutes of video" over-promises
 * for users of pricier models (the per-second spread across models is ~4×).
 * Rates come from MODEL_OLIVE_COSTS via oliveOutcomes (Kling 3.0 Pro base for
 * video, Nano Banana 2 at 1K for images); keep the names below in sync with
 * the models referenced there.
 */
export function useOliveOutcomeLabel(): (olives: number) => string {
  const t = useExtracted()
  return olives => {
    const o = oliveOutcomes(olives)
    return o.videoSeconds >= 120
      ? t('≈ {min} minutes of Kling 3.0 video (no audio) or {img} Nano Banana 2 images (1K)', {
          min: Math.round(o.videoSeconds / 60).toLocaleString(),
          img: o.images.toLocaleString(),
        })
      : t('≈ {sec} seconds of Kling 3.0 video (no audio) or {img} Nano Banana 2 images (1K)', {
          sec: o.videoSeconds.toLocaleString(),
          img: o.images.toLocaleString(),
        })
  }
}
